import { useContext } from "react";

import { Stepper } from "@/components/Stepper";

import { QREditorContext } from "@/contexts/QREditorContext";
import { getPageIndexFromUrl } from "@/utils/qrEditorNavigatorHelper";

import { QREditorStepperProps } from "./types";

export const QREditorStepper = ({ steps, pathname, variant = "labeled" }: QREditorStepperProps) => {
  const qrEditorContext = useContext(QREditorContext);
  const currentStep = getPageIndexFromUrl(pathname);

  const handleStepClick = (index: number) => {
    if (steps[index].onClick) {
      steps[index].onClick(index);
    }
  };

  const isStepEnabled = (index: number) => {
    return index <= qrEditorContext?.qrData.currentPageIndex;
  };

  const completedSteps = steps.map((_, index) => index < currentStep);

  return (
    <Stepper
      currentStep={currentStep}
      stepButtons={steps}
      completedSteps={completedSteps}
      onStepClick={handleStepClick}
      isStepEnabled={isStepEnabled}
      variant={variant}
    />
  );
};
